<div
    *ngIf="metrics && athlete"
    class="hub-settings-page"
    [style.--hub-custom-primary-color]="hubPrimaryColor"
    [style.--hub-custom-secondary-color]="hubSecondaryColor">
    <section class="settings-preview">
        <div
            class="preview-banner"
            [class.default-preview-banner]="!hasBannerImage()"
            [class.team-logo-banner-mark]="!hasBannerImage() && hasTeamLogo()"
            [style.--preview-banner-mark-image]="'url(' + getDefaultBannerLogo() + ')'"
            [style.backgroundImage]="hasBannerImage() ? 'url(' + getBannerImage() + ')' : null">
            <label class="upload-button banner-upload mat-focus-indicator mat-stroked-button mat-button-base">
                <input type="file" class="hidden" accept="image/*" (change)="onBannerChanage($event, 0)">
                <span class="mat-button-wrapper" *ngIf="!uploadingBanner">
                    <mat-icon>image</mat-icon>
                    {{hasBannerImage() ? 'Update Banner' : 'Add Banner'}}
                </span>
                <span class="mat-button-wrapper uploading" *ngIf="uploadingBanner">
                    <mat-spinner [diameter]="18"></mat-spinner>
                    {{uploadProgress}}%
                </span>
            </label>
        </div>

        <div class="preview-summary">
            <div class="preview-inner">
                <div class="portrait-shell">
                    <img
                        *ngIf="hasProfilePicture(); else noLogo"
                        class="portrait"
                        [src]="getLogo()"
                        (error)="onProfileImageError($event)">
                    <ng-template #noLogo>
                        <div class="portrait portrait-text">
                            {{athlete.firstname.charAt(0) | uppercase}}{{athlete.lastname.charAt(0) | uppercase}}
                        </div>
                    </ng-template>

                    <label class="upload-button portrait-upload mat-focus-indicator mat-flat-button mat-button-base">
                        <input type="file" class="hidden" accept="image/*" (change)="onBannerChanage($event, 1)">
                        <span class="mat-button-wrapper" *ngIf="!uploadingLogo">
                            <mat-icon>add_photo_alternate</mat-icon>
                            {{hasProfilePicture() ? 'Update Photo' : 'Add Photo'}}
                        </span>
                        <span class="mat-button-wrapper uploading" *ngIf="uploadingLogo">
                            <mat-spinner [diameter]="18"></mat-spinner>
                            {{uploadProgress}}%
                        </span>
                    </label>
                </div>

                <div class="preview-copy">
                    <h1>{{getNameForTitle()}}</h1>
                    <div class="preview-meta" *ngIf="getProfileQuote()">
                        <span>{{getProfileQuote()}}</span>
                    </div>
                </div>

                <div class="preview-actions">
                    <button mat-stroked-button class="share-button" (click)="copyProfileLink()">
                        <mat-icon>share</mat-icon>
                        Share
                    </button>
                </div>
            </div>
        </div>
    </section>

    <section class="settings-grid">
        <div class="settings-card">
            <div class="settings-card-header">
                <mat-icon>image</mat-icon>
                <div>
                    <h2>Profile Media</h2>
                    <p>Recommended: banner images around 1600 x 200 and profile photos around 512 x 512.</p>
                </div>
            </div>
        </div>

        <div class="settings-card">
            <div class="settings-card-header">
                <mat-icon>notes</mat-icon>
                <div>
                    <h2>About</h2>
                    <p>Add a short personal note for your Highlight Hub profile.</p>
                </div>
            </div>

            <mat-form-field appearance="outline" class="full-width" *ngIf="metrics?.profile">
                <textarea
                    matInput
                    rows="4"
                    placeholder="Add a short quote, motto, or profile note."
                    [(ngModel)]="metrics.profile.quote"
                    (ngModelChange)="emitMetricsChange()"
                    (blur)="saveProfile()">
                </textarea>
            </mat-form-field>
        </div>
    </section>
</div>
<div *ngIf="loadingMetrics" class="loading">
    <mat-spinner></mat-spinner>
</div>
